import { ReactComponent as Exclamation } from '../../assets/img/Exclamation.svg';
import { ReactComponent as Check } from '../../assets/img/green-check.svg';
import { ReactComponent as Waiter } from '../../assets/img/waiter.svg';
import { Button } from 'takeat-design-system-ui-kit';
import { WaitingPaymentConteiner } from "./style";

import React from 'react';

export default ({
  onSwitchPinpadCancelStatus,
  onResetPinpadOperation,
  onStartPinpadPayment,
  onSavePayment,
  currentPaymentFlow,
}) => {
  if (currentPaymentFlow === 'error') {
    return <WaitingPaymentConteiner>
      <div>
        <section>
          <Exclamation/>
        </section>
        <span>Algo deu errado</span>
        <div>
          <Button 
            onClick={onStartPinpadPayment}
            style={{
              backgroundColor: 'transparent',
              color: '#c8131b',
              border: '2px solid #c8131b',
              borderRadius: '12px',
              margin: 'auto'
            }} 
          >
            Tentar novamente
          </Button>
          <Button 
            onClick={onResetPinpadOperation}
            style={{
              backgroundColor: 'transparent',
              color: '#c8131b',
            }} 
          >
            Cancelar pagamento
          </Button>
        </div>
      </div>
    </WaitingPaymentConteiner>
  }

  if (currentPaymentFlow === 'success') {
    return <WaitingPaymentConteiner>
      <div>
        <section>
          <Check/>
        </section>
        <span>Pagamento realizado com sucesso</span>
        <div>
          <Button 
            onClick={onResetPinpadOperation}
            style={{
              backgroundColor: '#2EC9B7',
              color: 'white',
            }} 
          >
            Fechar e continuar
          </Button>
        </div>
      </div>
    </WaitingPaymentConteiner>
  }

  if (currentPaymentFlow === 'loading') {
    return <WaitingPaymentConteiner>
      <div>
        <Waiter/>
        <span>Aguardando Pagamento</span>
        <Button 
          onClick={onSwitchPinpadCancelStatus}
          style={{
            backgroundColor: 'transparent',
            color: '#c8131b',
            border: '2px solid #c8131b',
            borderRadius: '12px'
          }} 
        >
          Cancelar pagamento
        </Button>
      </div>
    </WaitingPaymentConteiner>
  }

  if (currentPaymentFlow === 'unsaved') {
    return <WaitingPaymentConteiner>
      <div>
        <section>
          <Exclamation/>
        </section>
        <span>Pagamento realizado, mas não salvo no sistema.</span>
        {/* <p>Tente novamente ou insira o pagamento manualmente.</p> */}
        <div>
          {/* <Button 
            onClick={onSavePayment}
            style={{
              backgroundColor: 'transparent',
              color: '#c8131b',
              border: '2px solid #c8131b',
              borderRadius: '12px',
              margin: 'auto'
            }} 
          >
            Tentar novamente
          </Button> */}
          <Button 
            onClick={onResetPinpadOperation}
            style={{
              backgroundColor: 'transparent',
              color: '#c8131b',
            }} 
          >
            Fechar e inserir manualmente
          </Button>
        </div>
      </div>
    </WaitingPaymentConteiner>
  }

  return <>
    ...
  </>
}